module.exports = __webpack_public_path__ + "static/moh-5d0ffe0e69cdc1a735fa5076eed6cf58.jpg";